export const jobPostMixin = {
  data () {
    return {
      apiUrl: null
    }
  },
  mounted () {
    const code = Math.floor(Math.random() * 10000)
    let url = 'https://beneat.co/job-posts/profile?callback=true'
    if (window.location.hostname === 'localhost' || window.location.hostname === 'dev.beneat.co' || window.location.hostname === 'customer.beneat-test.com') {
      const port = window.location.port ? `:${window.location.port}` : ''
      url = `http://${window.location.hostname}${port}/job-posts/profile?callback=true`
    }
    const callback = encodeURIComponent(url)
    this.apiUrl = `https://access.line.me/oauth2/v2.1/authorize?response_type=code&client_id=1657599244&redirect_uri=${callback}&code=${code}&state=${code}&scope=openid%20profile&bot_prompt=aggressive`
  }
}



// WEBPACK FOOTER //
// ./src/mixins/jobPostMixin.js